module.exports = __webpack_public_path__ + "static/media/promo.b5a295ca.mp4";